export enum ToolLevel {
	Mastered = "Mastered",
	AlreadyUsed = "AlreadyUsed"
}
